export const mergePagination = <T extends Record<string, any>>(
  field: string,
  existing: T,
  incoming: T,
  offset?: number
) => {
  if (offset === 0 || !existing?.[field]?.length) return incoming

  return {
    ...incoming,
    [field]: [...existing[field], ...incoming[field]]
  }
}
